import { DisbursementRoundStatusCode } from './disbursement-round.model';

// Client-side mirror of Disbursement::Rounds::StationResolver::STATUS_INDEX — same four
// stations, same order, same done/current/waiting derivation off the round's own
// sign-date columns. Shared by every surface that renders a round's sign-off progress
// from a flat set of round fields rather than the backend's own `approval_track` (which
// also carries resolved person_names and is only available via DisbursementRoundService) —
// the cover-memos hub (group endpoint's embedded round) and registry-detail (the cert's
// round-prefixed summary fields) both lack person_names and fetch nothing extra for it.
export interface RoundStepEntry {
  key: string;
  label: string;
  state: 'done' | 'current' | 'waiting';
  actedAt: string | null;
}

const ROUND_STATION_INDEX: Record<string, number> = {
  draft: 0,
  returned_to_officer: 0,
  pending_head: 1,
  pending_finance_sign: 2,
  pending_vice_dean_admin: 3,
  completed: 4,
  cancelled: 4,
};

export interface RoundStepInput {
  status_code: DisbursementRoundStatusCode | null | undefined;
  submitted_at: string | null | undefined;
  finance_signed_at: string | null | undefined;
  head_signed_at: string | null | undefined;
  vice_dean_signed_at: string | null | undefined;
}

export function buildRoundStationSteps(round: RoundStepInput): RoundStepEntry[] {
  const currentIndex = round.status_code != null ? ROUND_STATION_INDEX[round.status_code] ?? 0 : 0;
  const stations: { key: string; label: string; actedAt: string | null | undefined }[] = [
    { key: 'document_officer', label: 'เจ้าหน้าที่สารบรรณส่ง', actedAt: round.submitted_at },
    { key: 'head_of_department', label: 'หัวหน้าสาขาขอเบิก', actedAt: round.head_signed_at },
    { key: 'finance_officer', label: 'การเงินเห็นชอบ', actedAt: round.finance_signed_at },
    { key: 'vice_dean_administration', label: 'รองคณบดีฝ่ายบริหารอนุมัติ', actedAt: round.vice_dean_signed_at },
  ];

  return stations.map((station, index) => ({
    key: station.key,
    label: station.label,
    actedAt: station.actedAt ?? null,
    state: index < currentIndex ? 'done' : index === currentIndex ? 'current' : 'waiting',
  }));
}
